module.exports = __webpack_public_path__ + "static/img/1-7.db15265d.png";